import MainShape from './MainShapes.js';

export default class Entity extends MainShape {
  constructor(id, name, position) {
    super(id, name, 'Entity', position);
  }
}
